// extracted by mini-css-extract-plugin
export default {"container":"opstiUslovi_container__kDKep"};